import React, {FC, useCallback} from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import { useDispatch, useSelector } from 'react-redux';
import { IUserState } from '../../../../common/state/profile/user';
import { postEvent, updateEventById } from '../../../../common/async/AsyncCalls';
import { getParsedEPOCDate } from '../../../../common/helpers/CommonUtil';
import EventForm, { EventFormData } from '../../../../components/forms/events/Event.admin.form';
import { EVENT_ACTION_TYPE, IEvent, IEventState } from '../../../../common/state/events/event';
import SimpleSpinner from '../../../../components/loaders/spinners/SimpleSpinner';


const EventUpdateAdmin : FC = () => {
    const history = useHistory();
    const eventDispatch : (data : {type: EVENT_ACTION_TYPE, payload: any}) => void = useDispatch();
    // states    
    const selectedEvent: IEvent | undefined = useSelector(({event}: {event: IEventState}) => event.selected);
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    // lifecycle
    const updateEventDetails = useCallback(async(formData: EventFormData)=>{
        console.log('Update event');
        const start_date: number = getParsedEPOCDate(formData.startDate as string)
        const end_date: number = getParsedEPOCDate(formData.endDate as string);
        // console.log('Start and End date in number: ', start_date, end_date);
        if (!selectedEvent) return;
        try {
            await updateEventById(token, selectedEvent.id, {
                title: formData.title,
                description: formData.description,
                active: formData.status === 'active' ? true : false,
                start_date,
                end_date,
                image_url: formData.url
            });
            toast("Event updated successfully!");
            eventDispatch({type: EVENT_ACTION_TYPE.RESET_EVENT, payload: undefined});
            history.push({pathname: '/admin/events'});
        } catch (err) {
            console.log('Error updating event: ', (err as Error).message);
        }
    },[token, selectedEvent]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="flex flex-col items-start justify-start w-screen min-h-screen p-2 text-gray-700 bg-gray-200 lg:p-16 dark:bg-gray-800 dark:text-teal-400">
            <h2 className="mb-2 text-2xl text-gray-700 dark:text-teal-400">Update Event Details</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base">
                Update event defails. Please note that the fields marked with * are required.
            </p>
            <SimpleSpinner title='Loading details' loading={!selectedEvent}/>
            <EventForm defaultFormData={{
                title: selectedEvent?.title?? '',
                description: selectedEvent?.description?? '',
                url: selectedEvent?.image_url?? '',    
                status: selectedEvent?.active? 'active' : 'inactive',
                startDate: null,
                endDate: null,
            }}
                type='update'
                onSubmit={updateEventDetails}/>
        </div>
    </React.Fragment>
};

export default EventUpdateAdmin;
